export const FIELD_POSITIONS = {
  length: { row: { position: 1 }, col: { position: 1, span: 8 } },
  width: { row: { position: 1 }, col: { position: 2, span: 8 } },
  height: { row: { position: 1 }, col: { position: 2, span: 8 } },
  dim: { row: { position: 2 }, col: { position: 1 } },
  barcode: { row: { position: 3 }, col: { position: 1 } },
  'actualBarcode.optional': { row: { position: 3 }, col: { position: 2 } },
  'netWeight.optional': { row: { position: 5 }, col: { position: 1 } },
  'actualNetWeight.optional': { row: { position: 5 }, col: { position: 2 } },
  'grossWeight.optional': { row: { position: 6 }, col: { position: 1 } },
  'actualGrossWeight.optional': { row: { position: 6 }, col: { position: 2 } },
  'totalQuantity.optional': { row: { position: 7 }, col: { position: 1 } },
  'outerQuantity.optional': { row: { position: 7 }, col: { position: 1 } },
  'outerCarton.optional': { row: { position: 8 }, col: { position: 1 } },
  'result.optional': { row: { position: 9 }, col: { position: 1 } },
  'remark.optional': { row: { position: 10 }, col: { position: 1 } },
  'referenceMedia.optional': { row: { position: 10 }, col: { position: 2 } },
};
